import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { sharedBaseCardsStyles } from 'mui/components/sharedStyles/cardsStyles';
import { layoutHorizontalGapStyles } from 'mui/components/sharedStyles/layoutStyles';
import { StyledBannerDiscount } from 'mui/components/sharedStyles/textStyles';

export const StyledLocationContainer = styled('div')(
  ({ theme, isSelected }) => `
    ${sharedBaseCardsStyles({ theme })};
    border: none;
    ${layoutHorizontalGapStyles({ theme })};
    background-color: ${isSelected ? theme.DS_palette.background.lightBlue : theme.DS_palette.primary.white};
    padding: ${theme.DS_spacing(['sm'])};
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    position: relative;
    cursor: pointer;
    
    &:last-of-type {
      margin-bottom: ${theme.DS_spacing(['xl'])};
    }
  `,
);

export const StyledLocationHeader = styled('div')(
  ({ theme }) => `
    width: 100%;
    max-height: 30px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.DS_spacing(['xxs'])};
  `,
);

export const StyledDistancePlaceholder = styled(Typography)(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(113, 113, 113);
  
    ${theme.breakpoints.up('lg')} {
      font-size: 0.85rem;
    }
  `,
);

export const StyledFlagshipLabelWrapper = styled('div')(
  ({ theme }) => `

    ${theme.breakpoints.down('md')} {
      .MuiTypography-root {
        font-size: 0.rem;
        padding: ${theme.DS_spacing(['xxxs'])} ${theme.DS_spacing(['xxs'])};
      }
    }
  `,
);

export const StyledLocationContactWrapper = styled('div')(
  ({ theme }) => `
    h1 {
      margin-bottom: ${theme.DS_spacing(['xxs'])};
      word-break: break-word;
    }
    p {
      margin-bottom: 0;
    }
  `,
);

export const StyledArrowWrapper = styled('div')(
  ({ theme }) => `
    position: absolute;
    right: 20px;
    top: 52%;
    transform: translate(0, -52%);

    svg {
      fill: none;
      width: 32px;
      height: 32px;
      path {
        stroke: ${theme.DS_palette.buttons.enabled};
        stroke-width: 2.5px;
      }
    }
    
    ${theme.breakpoints.up('md')} {
      display: none;
    }
  `,
);

export const StyledDetailsWrapper = styled('div')(
  ({ theme }) => `
    padding-right: ${theme.DS_spacing(['xl'])};
    
    ${theme.breakpoints.up('md')} {
      padding-right: 0;
    }
  `,
);

export const StyledNoDates = styled('div')(
  ({ theme }) => `
  p{
    color: ${theme.DS_palette.text.secondary};  
    margin: ${theme.DS_spacing(['md'])} 0 0;
    }
 
    > div {
          
       margin-bottom: 0;
       margin-left: ${theme.DS_spacing(['xxxs'])};
       
      ${theme.breakpoints.down('lg')} {
        button{
        padding-bottom: 0;
       }
    }
    

      button > span > div  {
             margin: unset;
             margin-top:  ${theme.DS_spacing(['xxxs'])};
            
          svg{
            width: 24px;
            height: 24px;
    
            path {
               stroke-width: 0.5px;
               stroke:${theme.DS_palette.buttons.enabled};
               fill: ${theme.DS_palette.buttons.enabled};
           }
      
      }

       button:hover {
          box-shadow: none;
       }
    }
  `,
);

export const StyledWrapperDiscount = styled('div')(
  ({ theme }) => `
 
       ${StyledBannerDiscount({ theme })};
   `,
);
